import Cards from "./Components/Cards";
import Navbar from "./Components/Header";
import Landing from "./Components/Landing";
import { Route, Routes } from "react-router";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Landing />
              <Footer />
            </>
          }
        />
        <Route
          path="cards"
          element={
            <>
              <Cards />
              <Footer />
            </>
          }
        />
        <Route
          path="resume"
          element={
            <>
              <Resume />
              <Footer />
            </>
          }
        />
        <Route
          path="Portfolio"
          element={
            <>
              <Cards />
              <Footer />
            </>
          }
        />
        <Route
          path="contact"
          element={
            <>
              <Contact />
              <Footer />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
